import { OrderAssemblyState } from '../../../enums/OrderAssemblyState';

export class UpdateOrderAssemblyStateInput {
  orderId: number;
  userId?: number;
  orderAssemblyStateId: OrderAssemblyState;
  orderItemList: AssemblyOrderItemInput[];
}

export class AssemblyOrderItemInput {
  orderItemId: number;
  quantity: number;
}